export const checkboxStyle = {
  color: "var(--color-secondary)",
  "&.Mui-checked": {
    color: "var(--color-secondary)",
  },
  borderRadius: "6px",
  "& .MuiFormControlLabel-label": {
    fontWeight: "600",
  },
};
export const notiModalStyle = {
  position: "absolute",
  top: "15px",
  left: "10px",
  bgcolor: "white",
  borderRadius: "18px",
  width: {
    xs: "100%",
    sm: "450px",
    lg: "700px",
  },

  height: "97vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: 24,
};
export const tabsStyle = {
  backgroundColor: "#f5f5f5", // خلفية البار
  "& .MuiTabs-indicator": {
    display: "none",
  },
  direction: "rtl",
};
export const tabStyle = {
  fontFamily: "Cairo",
  fontWeight: "700",
  color: "#6c6c6c",
  "&.Mui-selected": {
    color: "#04545c",
  },
};
export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: "1100px", md: "800px", sm: "600px", xs: "350px" },
  bgcolor: "#fff",
  boxShadow: 24,
  p: { lg: 4, sm: 3, xs: 3 },
  borderRadius: "24px",
  outline: "none",
  maxHeight: "800px",
  overflowY: "scroll",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  zIndex: "1000",
  "&::-webkit-scrollbar": {
    width: "8px", // w-2 = 8px
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#e5e5e5", // gray-200
    borderRadius: "9999px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#6b7280", // gray-500
  },
};
export const selectStyle = {
  display: "flex",
  alignItems: "center",
  justifuContent: "center",
  backgroundColor: "rgba(227, 231, 234, 1)",
  borderRadius: "30px",
  padding: "4px 12px",
  fontSize: "14px",
  minWidth: 90,
  height: 36,
  "& fieldset": { border: 0 },
  "& svg": {
    color: "#212529",
    fontSize: "18px",
  },
};
export const pickerStyle = {
  "& .MuiPickersOutlinedInput-root": {
    height: "56px",
    backgroundColor: "rgba(227, 231, 234, 1)!important",
    borderRadius: "12px !important",
    "& fieldset": {
      border: "none !important",
    },
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "none !important",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "2px solid #3b82f6 !important",
  },
  "& .MuiInputBase-input": {
    fontSize: "0.75rem",
    color: "#1a1a1a",
    padding: "16px",
    height: "100%",
  },
};
